module.exports = __webpack_public_path__ + "img/consultation_cabinet.a7ada50c.png";